import { Link } from 'react-router-dom';
import { hotList } from '@/mocks/hotList';
import { topics } from '@/mocks/topics';
import SectionHeading from '@/components/feature/SectionHeading';
import HotRankRow from '@/components/feature/HotRankRow';

export default function RankingPreview() {
  const board = hotList.slice(0, 8);
  const topTopics = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="HOT RANKING"
          title="瓜圈速报热度排行"
          description="热度值综合公开讨论量、搜索热度、传播速度与互动密度加权计算，每 10 分钟滚动更新一次。"
          actionLabel="进入完整榜单"
          actionTo="/ranking"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-card border border-background-200 bg-background-50 p-2 md:p-3 lg:col-span-2">
            <div className="divide-y divide-background-100">
              {board.map((item, index) => (
                <HotRankRow key={item.id} item={item} rank={index + 1} />
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-card border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-pulse-line text-lg text-primary-500" />
                热度是怎么算的
              </h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                {[
                  { label: '公开讨论量', weight: '35%' },
                  { label: '搜索热度', weight: '25%' },
                  { label: '传播速度', weight: '25%' },
                  { label: '互动密度', weight: '15%' },
                ].map((row) => (
                  <li key={row.label} className="flex items-center justify-between">
                    <span>{row.label}</span>
                    <span className="font-medium text-foreground-900">{row.weight}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-4 border-t border-background-200 pt-3.5 text-xs leading-relaxed text-foreground-500">
                热度只反映话题声量，不代表我们对事件真假的判断。
              </p>
            </div>

            <div className="rounded-card border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-hashtag text-lg text-accent-600" />
                话题声量 TOP5
              </h3>
              <ol className="mt-4 space-y-3">
                {topTopics.map((topic, index) => (
                  <li key={topic.id}>
                    <Link
                      to={`/topics?topic=${topic.slug}`}
                      className="group flex items-center justify-between gap-3 text-sm"
                    >
                      <span className="flex min-w-0 items-center gap-2.5">
                        <span className="w-4 shrink-0 text-xs font-bold tabular-nums text-foreground-400">
                          {index + 1}
                        </span>
                        <span className="truncate text-foreground-800 transition-colors group-hover:text-primary-600">
                          {topic.name}
                        </span>
                      </span>
                      <span className="shrink-0 font-heading tabular-nums text-foreground-900">{topic.heat}</span>
                    </Link>
                  </li>
                ))}
              </ol>
              <Link
                to="/topics"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition hover:text-primary-700"
              >
                查看全部话题榜
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}